// Progress text or error message under a Download button (see DataDownload).
const DownloadStatus = ({ status, error }) => {
  if (error) {
    return (
      <div
        role="alert"
        style={{ color: '#9B2C2C', fontSize: '13px', marginTop: '6px' }}
      >
        Download failed: {error}
      </div>
    );
  }
  if (status) {
    return (
      <div
        role="status"
        aria-live="polite"
        style={{ color: '#2C3E37', fontSize: '13px', marginTop: '6px' }}
      >
        {status}
      </div>
    );
  }
  return null;
};

export default DownloadStatus;
